<!-- EXPRESSION ENGINE -->
<div *ngIf="mode==='expression'">
  <!--<h4 class="heading-prominent d-b m-b-15">Expression Engine</h4>-->
  <div *ngIf="!privilege || (privilege && privilege!='VIEW')">
  <div *ngIf="!disableEdit" class="editor-quill pos-relative" [class.quill-micro]="viewMode=='micro'">
    <!-- QUILL EDITOR -->
    <quill-editor #editor [(ngModel)]="expression" [modules]="modules" [placeholder]="'Start typing your expression...'"
      (onBlur)="editorOnBlur($event)" (onEditorChanged)="editorOnContentChange($event)" [sanitize]="false"
      [ngClass]="{'ql-custom': true}">

      <div quill-editor-toolbar>
        <!-- a `div` toolbar will override programmatic toolbar -->

        <!-- Size -->
        <!-- <span class="ql-formats">
          <select class="ql-size" [title]="'Size'">
            <option value="small"></option>
            <option selected></option>
            <option value="large"></option>
            <option value="huge"></option>
          </select>
        </span> -->
        <small class="q-info-help f-r p-r-5"> Auto-suggest Options: Use &#64; for Operators, Vocabularies | Use # for
          functions | Use $ for Temporary Variables </small>
        <h5 class="q-ttl">Build Expression</h5>

        <!-- Custom actions SAMPLE -- >
        <span class="ql-formats">
        <button [title]="'Signature'" >
          <i nz-icon nzType="heart"></i>
        </button>
        <button [title]="'Unsubscribe'">
          <i nz-icon nzType="heart"></i>
        </button>
        </span>
        <! -- -->

      </div>

    </quill-editor>

    <!-- Micro-Mode UI for VALIDATIONS etc -->
    <div class="micro-mode-validations" *ngIf="viewMode=='micro'">
      <div class="micro-mode-validation-icon">
        <span *ngIf="isParsing"><i nz-icon nzType="loading" nzTheme="outline"></i></span>
        <span *ngIf="!isParsing">
          <span class="col-green" *ngIf="currentValidationStatus" nz-tooltip nzPlacement="right" [nzTooltipTitle]="'Valid'">
            <i nz-icon nzType="check" nzTheme="outline"></i></span>
          <span class="col-red" *ngIf="!currentValidationStatus" nz-popover nzType="primary"
            nzPopoverTitle="Invalid Expression" [nzPopoverContent]="currentValidationMessage">
            <i nz-icon nzType="close" nzTheme="outline"></i></span>
        </span>
      </div>
      <div class="micro-mode-validation-icon">
        <span *ngIf="isParsing"><i nz-icon nzType="loading" nzTheme="outline"></i></span>
        <span *ngIf="!isParsing" class="unselectable">
          <span class="col-grey-dark" nz-popover nzType="primary" nzPopoverTitle="Expression View"
            [nzPopoverContent]="expressionTextWithDescriptions != 'null' ? expressionTextWithDescriptions : 'Expression not found'">
            <i nz-icon nzType="info-circle" nzTheme="outline"></i></span>
        </span>
      </div>
    </div>
  </div>
  </div>

  <ng-container *ngIf="viewMode!=='micro'">
    <div *ngIf="!disableEdit && (!privilege || (privilege && privilege!='VIEW'))" class="expression-helper m-t-15">
      <div class="expression-helper-box">
        <nz-tag [nzColor]="'blue'" class="exp-head">Helper info</nz-tag>
        <!-- Use format <code>DATEDIFF( startDate, endDate, .... )</code> for doing a date difference. The start date must be lesser than the end date. -->
        {{currentHelper}} <span *ngIf="!currentHelper" class="expression-helper-zero-state">You'll see information about
          selected Vocabulary or Function here,
          once you add one to the Build Expression. Make sure all constants are used inside single-inverted commas. Auto-suggest Annotations: Use &#64; for Operators, Vocabularies | Use #
          for
          functions | Use $ for Temporary Variables, Space is needed before use of any of the annotations </span>
      </div>
    </div>
    <div class="expression-results" *ngIf="expression">
      <div *ngIf="!disableEdit && (!privilege || (privilege && privilege!='VIEW'))">
        <nz-tag [nzColor]="'#0b5b14'" class="expression-results-small-head">Validity</nz-tag>
        <br />
        <nz-table nzSize="small" [nzData]="[null]" [nzShowPagination]="false">
          <tbody>
            <tr>
              <td><strong>Parsing</strong></td>
              <td *ngIf="expression">
                <span *ngIf="isParsing"><i nz-icon nzType="loading" nzTheme="outline"></i></span>
                <span *ngIf="!isParsing">
                  <span><i nz-icon nzType="check" nzTheme="outline"></i> Parsed</span>
                </span>
              </td>
            </tr>
            <tr>
              <td><strong>Expression Validity</strong></td>
              <td *ngIf="expression">
                <span *ngIf="isParsing"><i nz-icon nzType="loading" nzTheme="outline"></i></span>
                <span *ngIf="!currentValidationStatus">
                  <span class="col-red">
                    <!-- <i nz-icon nzType="cross" nzTheme="outline"></i>  -->
                    Invalid: [Expression not ready for Save]
                    {{'' + currentValidationMessage}}
                  </span>
                </span>
                <span *ngIf="currentValidationStatus">
                  <span class="col-green"><i nz-icon nzType="check" nzTheme="outline"></i> Looks Valid: [Expression ready for
                    Save, final validity of expression will be checked by Rule Engine]</span>
                </span>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
      <div>
        <nz-tag [nzColor]="'#155772'" class="expression-results-small-head">Expression</nz-tag>
        <div class="expression-result expression-output unselectable" [innerHTML]="expressionInnerHTMLWithDescription">
        </div>

        <!-- <div class="expression-result">{{HTMLData | json}}</div> -->
      </div>
    </div>
  </ng-container>
</div>

<!-- QUERY BUILDER -->


<div *ngIf="mode==='query'">
  <query-builder [(ngModel)]='query' [config]="config" [classNames]='classNames'>
    <!-- Customize Input SAMPLE -- [dj] EXTEND THIS CONCEPT FOR EACH INPUT TYPE ETC... -->
    <ng-container *queryInput="let rule; type: 'date'">
      <nz-date-picker [(ngModel)]="rule.value" nzFormat="dd MMM yyyy"></nz-date-picker>
    </ng-container>
  </query-builder>
  <nz-collapse [nzBordered]="false">
    <nz-collapse-panel [nzHeader]="'Output'" [nzActive]="false">
      <pre>
          {{query | json}}
        </pre>
    </nz-collapse-panel>
  </nz-collapse>
</div>